import React, { Component } from "react";
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown as ReactStrapDropDown,
} from "reactstrap";
import { QuoteStatus, QuoteMode } from "./../../utils/Quote/Quote";
import * as _state from "./_state";
import style from "./Quotebar.module.scss";
import Item from "./Item/Item";
import CrossItem from "./CrossItem/CrossItem";

let intervalExpiration = null;

class Quotebar extends Component {
  constructor(props) {
    super(props);

    _state.initialize.call(this);

    this.enableCounterAndExpirationsTask();
  }

  toggle = () => {
    _state.toggle.call(this);
  };

  getEditingProps(id) {
    const { edit } = this.state;
    if (edit && edit.AdvisorQuoteId == id) {
      return edit;
    }

    return {};
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.open) {
      if (!document.getElementById("overlay")) {
        let overlay = document.createElement("div");
        overlay.id = "overlay";
        overlay.className = style.overlay;

        document.body.appendChild(overlay);
        // enable timer quote expiration
        const { isAdvisor, quotes } = this.props;
        const { counter, expirations } = getCounterAndExpirations(isAdvisor, quotes, this.state.expirations);

        _state.updateStateProps.call(this, { counter, expirations });
      }
    } else {
      if (document.getElementById("overlay")) {
        document.body.removeChild(document.getElementById("overlay"));
      }
    }
  }

  enableCounterAndExpirationsTask = () => {
    if (intervalExpiration) {
      clearInterval(intervalExpiration);
    }

    intervalExpiration = setInterval(() => {
      const { isAdvisor, quotes } = this.props;
      const { counter, expirations } = getCounterAndExpirations(isAdvisor, quotes, this.state.expirations);

      if (!(this.state.counter == counter && !this.state.open)) {
        _state.updateStateProps.call(this, { counter, expirations });
      }
    }, 1000);
  };

  changeMode = (id, mode) => {
    _state.changeMode.call(this, id, mode);
  };

  updateQuote = () => {
    _state.setLoading.call(this, true);

    const params = _state.getUpdatedValues.call(this);

    this.props.updateQuote(params).then((response) => {
      setTimeout(() => _state.setLoading.call(this, false), 700);
    });
  };

  changeField = (name, value) => {
    _state.changeField.call(this, name, value);
  };

  render() {
    if (this.props.quotes == null) {
      return null;
    }

    const {
      quotes,
      crossing: pCrossing,
      isAdvisor,
      openModalOrder,
      openModalOffer,
      crossingSetPrice,
    } = this.props;
    const { counter: sCounter, expirations } = this.state;
    const crossing = pCrossing || [];

    const counter = sCounter + crossing.length;

    return (
      <ReactStrapDropDown nav isOpen={this.state.open} toggle={this.toggle}>
        <DropdownToggle nav>
          <span className={counter > 0 ? style.tada : null}>
            <i className="fa fa-dollar"></i>
            <Badge pill color="info">
              {counter}
            </Badge>
          </span>
        </DropdownToggle>
        <DropdownMenu right className="dropdown-menu-lg" className={style.container}>
          <DropdownItem header tag="div">
            <strong>Quote list</strong>
          </DropdownItem>
          {this.state.open && (
            <div className={style.quotes}>
              {quotes.length == 0 && crossing.length == 0 ? (
                <h5>Empty</h5>
              ) : (
                <React.Fragment>
                  {crossing.map((order) => (
                    <CrossItem key={`o-${order.OrderId}`} order={order} setPrice={crossingSetPrice} />
                  ))}

                  {quotes.map((item) => {
                    const editingProps = this.getEditingProps(item.AdvisorQuoteId);
                    return (
                      <Item
                        key={`quote-${item.AdvisorQuoteId}`}
                        quote={{
                          ...item,
                          mode: editingProps.mode || item.mode,
                          ...expirations[item.AdvisorQuoteId],
                        }}
                        openModalOrder={openModalOrder}
                        openModalOffer={openModalOffer}
                        changeMode={this.changeMode}
                        changeField={this.changeField}
                        updateQuote={this.updateQuote}
                        isAdvisor={isAdvisor}
                        {...editingProps}
                      />
                    );
                  })}
                </React.Fragment>
              )}
            </div>
          )}
        </DropdownMenu>
      </ReactStrapDropDown>
    );
  }
}

const getExpirationValue = (quote) => {
  const { AdvisorQuoteExpireAt, AdvisorQuoteStatus } = quote;
  const diffSeconds = Math.max(parseInt((AdvisorQuoteExpireAt - new Date()) / 1000), 0);
  return {
    expired: AdvisorQuoteStatus == QuoteStatus.PRICED && diffSeconds <= 0,
    expirateIn: diffSeconds,
  };
};

const getCounterAndExpirations = (isAdvisor, quotes, expirations) => {
  let counter = 0;
  let _expirations = expirations;

  quotes.forEach((q) => {
    _expirations[q.AdvisorQuoteId] = getExpirationValue(q);

    if (isAdvisor) {
      if (q.AdvisorQuoteStatus == QuoteStatus.PRICED) {
        counter++;

        if (_expirations[q.AdvisorQuoteId].expired == true) {
          counter--;
        }
      }
    } else {
      if (q.AdvisorQuoteStatus == QuoteStatus.WAITING) {
        counter++;
      }
    }
  });

  return {
    counter,
    expirations: _expirations,
  };
};

export default Quotebar;
